class Lieu {
    constructor(pathToImage, designation, distance, adresse, description
        , heureFermeture, heureOuverture, position, reservation, service,
        type, telephone, prixMin, prixMax, adresseAprox
        , ville, selectedArrondisement, sendBy, categorie, anonymous) {
        this.pathToImage = pathToImage;
        this.designation = designation;
        this.distance = distance;
        this.adresse = adresse;
        this.description = description;
        this.heureFermeture = heureFermeture;
        this.heureOuverture = heureOuverture;
        this.position = position;
        this.reservation = reservation;
        this.service = service;
        this.type = type;
        this.telephone = telephone;
        this.prixMin = prixMin;
        this.prixMax = prixMax;
        this.adresseAprox = adresseAprox;
        this.ville = ville;
        this.selectedArrondisement = selectedArrondisement;
        this.sendBy = sendBy;
        this.categorie = categorie;
        this.anonymous = anonymous;
    }
    addUid(uid) {
        this.id = uid;
    }
}


class Position {
    constructor(latitude, longitude) {
        this.latitude = latitude;
        this.longitude = longitude;
    }
}

class Reservation {
    constructor(numero, state) {
        this.numero = numero;
        this.state = state;
    }

}

class Service {
    constructor(boulangerie, patisserie) {
        this.boulangerie = boulangerie;
        this.patisserie = patisserie;
    }
}

class Menu {
    constructor(designation, prix) {
        this.designation = designation;
        this.prix = prix;
    }
}

class UserSend {
    constructor(pathToImage, name) {
        this.pathToImage = pathToImage;
        this.name = name;
    }
}

export { Reservation, Position, Menu, Service, UserSend };

export default Lieu;
